import React from 'react';
import { CardElement } from 'react-stripe-elements';

class StripeCardInput extends React.Component {
  componentDidMount() {
    const { updateFieldValidityManually } = this.props;
    if (updateFieldValidityManually) {
      updateFieldValidityManually(
        this.props,
        false,
        null,
        'form.field.error_text.required'
      );
    }
  }

  render() {
    const { isValid, updateFieldValidityManually, disabled } = this.props;
    return (
      <div className="FormInput FormInput--stripe-card FormInput--text-single FormInput--text">
        <CardElement
          onChange={e => {
            if (e.complete && !isValid)
              updateFieldValidityManually(this.props, true, null, null);
            if (e.error)
              updateFieldValidityManually(
                this.props,
                false,
                e.error.message,
                null
              );
          }}
          className={`FormInput__input ${disabled ? 'is-disabled' : ''}`}
          disabled={disabled}
          style={{
            base: {
              fontSize: '18px',
              fontFamily: '"AvenirLTStd-Roman", sans-serif',
              ':disabled': {
                color: '#7A7A7A',
              },
              '::placeholder': {
                color: '#9B9B9B',
              },
            },
          }}
        />
      </div>
    );
  }
}

export default StripeCardInput;
